import { Select, SelectItem } from "@heroui/react";

/**
 * StaticSelect - For small static lists (no searching needed)
 * Use this for dropdowns with fewer than ~20 items where searching is unnecessary.
 * For large/searchable lists, use SelectDropdown (Autocomplete-based).
 */
export const StaticSelect = ({
  options = [],
  label = "Select an option",
  onChange,
  value,
  required = false,
  name,
  disabled = false,
  error = false,
  errorMsg,
  description,
  placeholder = "Select an option",
  size = "md",
  variant = "default", // "default" or "prominent" for edit mode
}) => {
  const selectedKey = value ? String(value) : undefined;

  const handleSelectionChange = (keys) => {
    const key = keys?.currentKey || (keys instanceof Set ? [...keys][0] : keys);
    if (onChange && key !== undefined) {
      onChange({ target: { name, value: key } });
    }
  };

  const triggerClasses = variant === "prominent"
    ? "h-12 !bg-white border-2 border-surface-border hover:border-primary/40 data-[focus=true]:border-primary data-[focus=true]:ring-4 data-[focus=true]:ring-primary/15 transition-all duration-200"
    : "h-12 bg-lightgrey border border-surface-border hover:border-surface-border data-[focus=true]:border-primary/50 transition-colors";

  return (
    <Select
      label={label}
      labelPlacement="inside"
      placeholder={placeholder}
      size={size}
      isRequired={required}
      isDisabled={disabled}
      isInvalid={error}
      errorMessage={errorMsg}
      description={description}
      selectedKeys={selectedKey ? new Set([selectedKey]) : new Set()}
      onSelectionChange={handleSelectionChange}
      classNames={{
        base: "font-sans",
        label: "scale-90 group-data-[focus=true]:-translate-y-2.5 group-data-[focus=true]:scale-75 group-data-[filled=true]:-translate-y-2.5 group-data-[filled=true]:scale-75 font-sans text-grey group-data-[focus=true]:text-primary",
        trigger: triggerClasses,
        value: "text-sm text-darkgrey font-sans",
        listbox: "bg-white",
        popoverContent: "bg-white border border-surface-border rounded-lg shadow-lg",
        errorMessage: "text-xs text-danger font-sans",
      }}
      scrollShadowProps={{ isEnabled: false }}
    >
      {options.map((item) => (
        <SelectItem
          key={item.id}
          textValue={item.name}
          classNames={{
            base: "data-[hover=true]:bg-lightgrey data-[selected=true]:bg-secondary/10 data-[selected=true]:text-secondary-dark",
            title: "text-sm text-darkgrey font-sans",
          }}
        >
          {item.name}
        </SelectItem>
      ))}
    </Select>
  );
};

export default StaticSelect;
